<template>
  <main>
    <component v-bind:is="templateName"></component>
  </main>
</template>

<script>

import HomePage from "../components/belfast/PageHome";
import GliderPhasePage from "../components/belfast/PageGliderPhase2";
import OptionsPage from "../components/belfast/PagePhase2Option";
import WebinarPage from "../components/belfast/PageWebinar";
import PrivacyPage from "../components/belfast/PagePrivacy";
import FaqPage from "../components/belfast/PageFaq";
import FeedbackPage from "../components/belfast/PageFeedback";
import Schemes from "../components/customPages/schemes";
import HaveYourSay from "../components/belfast/HaveYourSay";
import HaveYourSay2 from "../components/belfast/HaveYourSay2";
import ThankYou from "../components/belfast/ThankYou";
export default {
  name: "TemplateLoader",
  components: {
    ThankYou,
    HomePage,
    GliderPhasePage,
    OptionsPage,
    WebinarPage,
    PrivacyPage,
    FaqPage,
    FeedbackPage,
    HaveYourSay,
    HaveYourSay2
  },
  data() {
    return {};
  },
  computed: {
    templateName() {
      return this.$route.params.templateName;
    },
  },
  created() {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>
